module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/correctPick-50cc05b5008dfa3519db9b2d7b475788.svg";